import { toaster } from 'components/ui/toaster';
import { toastDuration } from 'config/toast';
import { captureClassifiedException } from 'utils/captureClassifiedException';
import { type ClassifiedError } from 'utils/classifyError';

const GLOBAL_MUTATION_ERROR_TOAST_ID = 'global-mutation-error';

type HandleMutationErrorOptions = {
  expectedCodeErrors?: string[];
  onExpected?: (classified: ClassifiedError) => void;
};

export function showUnexpectedMutationErrorToast(classified: ClassifiedError): void {
  if (classified.expectation === 'expected') {
    return;
  }

  if (toaster.isVisible(GLOBAL_MUTATION_ERROR_TOAST_ID)) {
    return;
  }

  toaster.create({
    id: GLOBAL_MUTATION_ERROR_TOAST_ID,
    type: 'error',
    title: classified.userMessage.title,
    description: classified.userMessage.description,
    duration: toastDuration,
    closable: true,
  });
}

/**
 * Opt-in handler for mutations that suppress the global cache handler and need
 * local branching (e.g. wrong-password 404). Most mutations need no `onError`.
 */
export function handleMutationError(
  error: unknown,
  options?: HandleMutationErrorOptions
): ClassifiedError {
  const classified = captureClassifiedException(error, {
    source: 'async',
    layer: 'action',
    expectedCodeErrors: options?.expectedCodeErrors,
  });

  if (classified.expectation === 'expected') {
    options?.onExpected?.(classified);
    return classified;
  }

  showUnexpectedMutationErrorToast(classified);
  return classified;
}
